import { render, staticRenderFns } from "./floorProductCoverSetting.vue?vue&type=template&id=a208b5e0&scoped=true"
import script from "./floorProductCoverSetting.vue?vue&type=script&lang=js"
export * from "./floorProductCoverSetting.vue?vue&type=script&lang=js"
import style0 from "./floorProductCoverSetting.vue?vue&type=style&index=0&id=a208b5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a208b5e0",
  null
  
)

export default component.exports